export default {"default":{"default":"intl/messages.b20a4a5702de2d51.json"}};